var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form-dashboard" },
    [
      _c("div", { attrs: { id: "TrashBinList" } }, [
        _c("div", { staticClass: "header" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "header-text" }, [
            _c("h1", [_vm._v(_vm._s(_vm.$t("form.trashBinList.title")))]),
            _vm._v(" "),
            _c("p", [_vm._v(_vm._s(_vm.$t("form.trashBinList.description")))]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "container" }, [
          _vm.loading
            ? _c("div", { staticClass: "loading-container" }, [
                _c("div", { staticClass: "loading-spinner" }),
                _vm._v(" "),
                _c("p", { staticClass: "loading-text" }, [
                  _vm._v(_vm._s(_vm.$t("form.trashBinList.loading"))),
                ]),
              ])
            : _vm.deletedFormsWithColors.length > 0
            ? _c(
                "div",
                { staticClass: "form-grid" },
                _vm._l(_vm.deletedFormsWithColors, function (form) {
                  return _c(
                    "div",
                    {
                      key: form._id,
                      staticClass: "list-card",
                      class: {
                        selected:
                          _vm.selectedForm && _vm.selectedForm._id === form._id,
                      },
                      style: { "--border-color": form.color },
                      on: {
                        click: function ($event) {
                          return _vm.formId(form._id)
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "card-header" }, [
                        _c(
                          "div",
                          {
                            staticClass: "icon-section",
                            style: { backgroundColor: form.color },
                          },
                          [
                            _c("i", { staticClass: "md-icon" }, [
                              _vm._v("article"),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "text-section" }, [
                          _c("div", { staticClass: "title" }, [
                            _vm._v(_vm._s(form.title)),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "deleted-date" }, [
                            _vm._v(
                              _vm._s(_vm.formatDeletedDate(form.trashedAt))
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "actor-info" }, [
                            form.createdBy && form.createdBy.name
                              ? _c("span", { staticClass: "actor-item" }, [
                                  _c("i", { staticClass: "md-icon" }, [
                                    _vm._v("person_add"),
                                  ]),
                                  _vm._v(
                                    _vm._s(form.createdBy.name) +
                                      "\n                                "
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            form.trashedBy && form.trashedBy.name
                              ? _c(
                                  "span",
                                  { staticClass: "actor-item actor-trashed" },
                                  [
                                    _c("i", { staticClass: "md-icon" }, [
                                      _vm._v("delete"),
                                    ]),
                                    _vm._v(
                                      _vm._s(form.trashedBy.name) +
                                        "\n                                "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "action-section" }, [
                        _c(
                          "button",
                          {
                            directives: [
                              {
                                name: "tippy",
                                rawName: "v-tippy",
                                value: {
                                  content: _vm.$t("form.trashBinList.restore"),
                                  placement: "top",
                                },
                                expression:
                                  "{ content: $t('form.trashBinList.restore'), placement: 'top' }",
                              },
                            ],
                            staticClass: "action-btn restore",
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.showRestoreModal(form)
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "md-icon" }, [
                              _vm._v("restore"),
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.$t("form.trashBinList.restore"))
                              ),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            directives: [
                              {
                                name: "tippy",
                                rawName: "v-tippy",
                                value: {
                                  content: _vm.$t(
                                    "form.trashBinList.permanentDelete"
                                  ),
                                  placement: "top",
                                },
                                expression:
                                  "{ content: $t('form.trashBinList.permanentDelete'), placement: 'top' }",
                              },
                            ],
                            staticClass: "action-btn permanent-delete",
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.showPermanentDeleteModal(form)
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "md-icon" }, [
                              _vm._v("delete_forever"),
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.$t("form.trashBinList.delete"))
                              ),
                            ]),
                          ]
                        ),
                      ]),
                    ]
                  )
                }),
                0
              )
            : _c("div", { staticClass: "empty-state" }, [
                _c("div", { staticClass: "empty-icon" }, [
                  _c(
                    "svg",
                    {
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "currentColor",
                        "stroke-width": "2",
                      },
                    },
                    [
                      _c("path", { attrs: { d: "M3 6h18" } }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          d: "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2",
                        },
                      }),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("h3", [
                  _vm._v(_vm._s(_vm.$t("form.trashBinList.emptyTitle"))),
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(_vm._s(_vm.$t("form.trashBinList.emptyDescription"))),
                ]),
              ]),
        ]),
      ]),
      _vm._v(" "),
      _vm.selectedForm
        ? _c("div", { staticClass: "form-details" }, [
            _c("div", { staticClass: "details-card" }, [
              _c("h3", { staticClass: "card-title" }, [
                _vm._v(_vm._s(_vm.selectedForm.title || "-")),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "deleted-time" }, [
                _vm._v(
                  _vm._s(_vm.formatDeletedDate(_vm.selectedForm.trashedAt))
                ),
              ]),
              _vm._v(" "),
              _c("ul", { staticClass: "info-list" }, [
                _vm.selectedForm.createdBy && _vm.selectedForm.createdBy.name
                  ? _c("li", [
                      _c("span", { staticClass: "label" }, [
                        _vm._v(_vm._s(_vm.$t("form.trashBinList.createdBy"))),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "value" }, [
                        _vm._v(_vm._s(_vm.selectedForm.createdBy.name)),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.selectedForm.trashedBy && _vm.selectedForm.trashedBy.name
                  ? _c("li", [
                      _c("span", { staticClass: "label" }, [
                        _vm._v(_vm._s(_vm.$t("form.trashBinList.trashedBy"))),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "value" }, [
                        _vm._v(_vm._s(_vm.selectedForm.trashedBy.name)),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("li", [
                  _c("span", { staticClass: "label" }, [
                    _vm._v(_vm._s(_vm.$t("form.trashBinList.totalResponses"))),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "value" }, [
                    _vm._v(_vm._s(_vm.selectedForm.total || 0)),
                  ]),
                ]),
                _vm._v(" "),
                _c("li", [
                  _c("span", { staticClass: "label" }, [
                    _vm._v(_vm._s(_vm.$t("form.trashBinList.unread"))),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "value" }, [
                    _vm._v(_vm._s(_vm.selectedForm.unreadCount || 0)),
                  ]),
                ]),
                _vm._v(" "),
                _c("li", [
                  _c("span", { staticClass: "label" }, [
                    _vm._v(_vm._s(_vm.$t("form.trashBinList.read"))),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "value" }, [
                    _vm._v(_vm._s(_vm.selectedForm.readCount || 0)),
                  ]),
                ]),
                _vm._v(" "),
                _c("li", [
                  _c("span", { staticClass: "label" }, [
                    _vm._v(_vm._s(_vm.$t("form.trashBinList.archived"))),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "value" }, [
                    _vm._v(_vm._s(_vm.selectedForm.archivedCount || 0)),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "action-buttons" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn-restore",
                    on: {
                      click: function ($event) {
                        return _vm.showRestoreModal(_vm.selectedForm)
                      },
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "justify-content": "center",
                          "align-items": "center",
                          gap: "5px",
                        },
                      },
                      [
                        _vm._m(1),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "font-size": "12px",
                              "font-weight": "bold",
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("form.trashBinList.restore")))]
                        ),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn-delete",
                    on: {
                      click: function ($event) {
                        return _vm.showPermanentDeleteModal(_vm.selectedForm)
                      },
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "justify-content": "center",
                          "align-items": "center",
                          gap: "5px",
                        },
                      },
                      [
                        _vm._m(2),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "font-size": "12px",
                              "font-weight": "bold",
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("form.trashBinList.delete")))]
                        ),
                      ]
                    ),
                  ]
                ),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.restoreModal
        ? _c("DeleteModal", {
            attrs: {
              description: _vm.$t(
                "form.trashBinList.restoreConfirmDescription"
              ),
              btnCancelText: _vm.$t("message.cancel"),
              btnoktext: _vm.$t("form.trashBinList.restore"),
            },
            on: {
              cancel: function ($event) {
                _vm.restoreModal = false
              },
              confirm: _vm.confirmRestore,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.permanentDeleteModal
        ? _c("DeleteModal", {
            attrs: {
              description: _vm.$t("form.trashBinList.deleteConfirmDescription"),
              btnCancelText: _vm.$t("message.cancel"),
              btnoktext: _vm.$t("form.trashBinList.permanentDelete"),
            },
            on: {
              cancel: function ($event) {
                _vm.permanentDeleteModal = false
              },
              confirm: _vm.confirmPermanentDelete,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header-logo" }, [
      _c("span", { staticClass: "md-icon" }, [_vm._v("delete_outline")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [_c("i", { staticClass: "md-icon" }, [_vm._v("restore")])])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("i", { staticClass: "md-icon" }, [_vm._v("delete_forever")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }